/**
 * Converts a percent-scale value (5 meaning 5%) to its fraction (0.05).
 * Latitude's Ticker multiplies `type="percentage"` values by 100, so
 * percent-scale API fields (e.g. AssetTypeInfo.dayChange) must be scaled
 * down through this helper before being passed to it.
 */
export function percentToFraction(percent: number | string): number {
  return Number(percent) / 100;
}
